module.exports = __webpack_public_path__ + "media/images/questionnaires/favicon-935abab3f59bdfb2a1f50d79d62d4a91.png";